export class GameLoop {
  private lastTime = 0;
  private isRunning = false;
  private animFrameId = 0;
  private updateCallback: ((dt: number) => void) | null = null;

  start(): void {
    this.isRunning = true;
    this.lastTime = performance.now();
    this.loop(this.lastTime);
  }

  stop(): void {
    this.isRunning = false;
    if (this.animFrameId) {
      cancelAnimationFrame(this.animFrameId);
    }
  }

  onUpdate(callback: (dt: number) => void): void {
    this.updateCallback = callback;
  }

  private loop(currentTime: number): void {
    if (!this.isRunning) return;

    const dt = Math.min((currentTime - this.lastTime) / 1000, 0.05);
    this.lastTime = currentTime;

    if (this.updateCallback) {
      this.updateCallback(dt);
    }

    this.animFrameId = requestAnimationFrame((t) => this.loop(t));
  }
}
